<template>
  <div class="systemConfig">
    <el-button
      type="primary"
      size="small"
      @click="openAdd()"
      style="margin-right: 20px;background-color: #409eff;color: white;border: 1px solid #d9ecff;"
      >新增</el-button
    >
    <el-button
      type="warning"
      size="small"
      @click="getList()"
      style="margin-right: 20px"
      >刷新数据</el-button
    >
    <el-button
      type="info"
      size="small"
      style="margin-right: 20px"
      @click="viewLinkDialog = true"
      >查看内部跳转链接</el-button
    >
    <el-tabs
      class="card"
      v-model="activeName"
      type="card"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <el-tab-pane
        :label="`${item[0].groupName}(${item[0].gpCode})`"
        :name="`${index.toString()}`"
        v-for="(item, index) in tableData"
        :key="item.id"
      >
        <el-button
          type="primary"
          size="small"
          @click="openAdd(item[0])"
          style="margin-bottom: 10px"
          >添加变量</el-button
        >
        <div class="titleBox">
          <div class="leftBox">变量标题</div>
          <div class="rightBox">变量值</div>
        </div>
        <div class="contentBox">
          <el-form :model="data" label-width="200px" label-position="left">
            <el-form-item v-for="(subItem, subIndex) in item" :key="subItem.id">
              <template slot="label">
                <span
                  >{{ subItem.title }}(<span class="tip">{{
                    subItem.vCode
                  }}</span
                  >)</span
                >
              </template>
              <div class="itemBoxs">
                <div class="itemBox">
                  <div class="objBox" v-if="subItem.type === 'object'">
                    <el-row :gutter="10">
                      <el-col :span="10">键名</el-col>
                      <el-col :span="14">键值</el-col>
                    </el-row>
                    <el-row
                      :gutter="10"
                      v-for="(values, index) in subItem.values"
                      :key="index"
                    >
                      <el-col :span="10"
                        ><el-input type="text" v-model="values.key"></el-input
                      ></el-col>
                      <el-col :span="10"
                        ><el-input type="text" v-model="values.value"></el-input
                      ></el-col>
                      <el-col :span="4"
                        ><el-button
                          type="danger"
                          size="mini"
                          @click="deleteValue(subItem, index)"
                          >X</el-button
                        >
                      </el-col>
                    </el-row>
                    <el-button
                      size="mini"
                      type="success"
                      @click="addNode(subItem)"
                      >追加</el-button
                    >
                  </div>
                  <div
                    class="objBox"
                    v-if="
                      subItem.type === 'text-array' ||
                        subItem.type == 'string-array'
                    "
                  >
                    <el-row
                      :gutter="24"
                      v-for="(values, index) in subItem.values"
                      :key="index"
                      class="stringArrayBox"
                    >
                      <el-col :span="20"
                        ><el-input
                          type="text"
                          v-model="subItem.values[index]"
                          v-if="subItem.type === 'string-array'"
                        ></el-input>
                        <el-input
                          type="textarea"
                          :rows="3"
                          v-model="subItem.values[index]"
                          v-else
                        ></el-input
                      ></el-col>
                      <el-col :span="4"
                        ><el-button
                          type="danger"
                          size="mini"
                          @click="deleteValue(subItem, index)"
                          >X</el-button
                        >
                      </el-col>
                    </el-row>
                    <el-button
                      size="mini"
                      type="success"
                      @click="addNode(subItem, 'text')"
                      >追加</el-button
                    >
                  </div>
                  <el-input
                    v-if="subItem.type === 'text'"
                    type="textarea"
                    rows="3"
                    v-model="subItem.value"
                  ></el-input>
                  <el-input
                    v-else-if="subItem.type == 'string'"
                    v-model="subItem.value"
                  ></el-input>
                  <div
                    class="itemBoxs-select-box"
                    v-else-if="subItem.type == 'select'"
                  >
                    <el-select
                      v-model="subItem.value"
                      size="small"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in subItem.selectValues"
                        :key="item.key"
                        :label="item.key"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <el-button
                      class="itemBoxs-select-btn"
                      type="primary"
                      size="small"
                      @click.stop="clickUpdateSelect(1, subItem)"
                      >修改选择项</el-button
                    >
                  </div>
                  <base-upload-new
                    v-else-if="subItem.type == 'img'"
                    :cover="subItem.value"
                    :action="uploadUrl"
                    :groupIndex="index"
                    :index="subIndex"
                    @successCallback="uploadImgs"
                    :width="'120px'"
                    :height="'120px'"
                    :hide="true"
                  ></base-upload-new>
                  <el-input
                    v-else-if="subItem.type === 'int'"
                    v-model="subItem.value"
                  ></el-input>
                  <el-input
                    v-else-if="subItem.type === 'float'"
                    v-model="subItem.value"
                  ></el-input>
                  <el-switch
                    active-text="是"
                    inactive-text="否"
                    active-value="1"
                    inactive-value="0"
                    v-else-if="subItem.type === 'bool'"
                    v-model="subItem.value"
                  ></el-switch>
                  <!-- 查看图片 -->
                  <el-button
                    style="margin-left: 20px;"
                    size="mini"
                    type="success"
                    v-if="subItem.type == 'img'"
                    @click="viewImg(subItem)"
                    >查看图片</el-button
                  >
                  <el-button
                    class="delBtn"
                    type="danger"
                    size="mini"
                    @click="del(subItem)"
                    >X</el-button
                  >
                </div>
                <div class="tip">{{ subItem.tip }}</div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div
      style="display: flex;align-items: center;justify-content: center;margin-bottom: 50px;"
    >
      <el-button
        type="success"
        size="small"
        @click="submitUpdate()"
        v-if="tableData[activeName]"
        >更新（{{ tableData[activeName][0].groupName }}）组</el-button
      >
    </div>
    <el-dialog
      title="新增"
      :visible.sync="dialogVisible"
      width="700px"
      @before-close="handleClose"
      @close="handleClose"
    >
      <el-form :model="form" label-width="120px" :rules="rules" ref="form">
        <el-row>
          <el-form-item
            size="small"
            label="分组编码:"
            prop="gpCode"
            style="width: 480px"
          >
            <el-input :disabled="isDisabled" v-model="form.gpCode"></el-input>
          </el-form-item>
          <el-form-item
            size="small"
            label="分组名:"
            prop="groupName"
            style="width: 480px"
          >
            <el-input
              :disabled="isDisabled"
              v-model="form.groupName"
            ></el-input>
          </el-form-item>
          <el-form-item
            size="small"
            label="类型:"
            prop="type"
            style="width: 480px"
          >
            <el-select v-model="form.type" @change="form.value = ''" placeholder="请选择类型">
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="item in types"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24" v-if="form.type == 'object'">
            <el-form-item label="变量值:">
              <div class="objectBox">
                <el-row :gutter="10">
                  <el-col :span="8">键名</el-col>
                  <el-col :span="16">键值</el-col>
                </el-row>
                <el-row
                  :gutter="10"
                  v-for="(values, index) in objValues"
                  :key="index"
                >
                  <el-col :span="4"
                    ><el-input type="text" v-model="values.key"></el-input
                  ></el-col>
                  <el-col :span="16"
                    ><el-input type="text" v-model="values.value"></el-input
                  ></el-col>
                  <el-col :span="4"
                    ><el-button
                      type="danger"
                      size="mini"
                      @click="deleteValueAll(index)"
                      >X</el-button
                    >
                  </el-col>
                </el-row>
                <el-button size="mini" type="success" @click="addNodeAll()"
                  >追加</el-button
                >
              </div>
            </el-form-item>
          </el-col>
          <el-col
            :span="24"
            v-else-if="form.type == 'text-array' || form.type == 'string-array'"
          >
            <el-form-item label="变量值:">
              <div class="objectBox">
                <el-row
                  :gutter="24"
                  v-for="(el, index) in textArray"
                  :key="index"
                  class="stringArrayBox"
                >
                  <el-col :span="20"
                    ><el-input
                      type="text"
                      style="width: 200px;"
                      v-model="textArray[index]"
                      v-if="form.type === 'string-array'"
                    ></el-input>
                    <el-input
                      type="textarea"
                      :rows="3"
                      v-model="textArray[index]"
                      v-else
                    ></el-input>
                  </el-col>
                  <el-col :span="4"
                    ><el-button
                      type="danger"
                      size="mini"
                      @click="deleteValueAll(index, 'text')"
                      >X</el-button
                    >
                  </el-col>
                </el-row>
                <el-button
                  size="mini"
                  type="success"
                  @click="addNodeAll('text')"
                  >追加</el-button
                >
              </div>
            </el-form-item>
          </el-col>
           <!-- select类型 -->
           <el-col
            :span="24"
            v-else-if="form.type == 'select'"
            style="display: flex; align-items: center;"
          >
            <el-form-item label="变量值:" size="small" style="width: 480px;">
              <el-select v-model="form.value" placeholder="请选择">
                <el-option
                  v-for="item in form.selectValues"
                  :key="item.key"
                  :label="item.key"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-button
              type="primary"
              style="margin-left: 10px; margin-top: -28px;"
              size="small"
              @click.stop="clickUpdateSelect"
              >修改选择项</el-button
            >
          </el-col>
          <el-col v-else>
            <el-form-item
              size="small"
              label="变量值:"
              prop="value"
              style="width: 480px"
            >
              <el-input
                v-if="form.type == 'text'"
                v-model="form.value"
                type="textarea"
                rows="3"
              ></el-input>
              <el-input
                v-else-if="form.type == 'string'"
                v-model="form.value"
              ></el-input>
              <base-upload
                v-else-if="form.type == 'img'"
                :cover="form.value"
                :action="uploadUrl"
                @successCallback="uploadImg"
                :width="'120px'"
                :height="'120px'"
                :hide="true"
              ></base-upload>
              <el-input
                v-else-if="form.type === 'int'"
                v-model="form.value"
              ></el-input>
              <el-input
                v-else-if="form.type === 'float'"
                v-model="form.value"
              ></el-input>
              <el-switch
                active-text="是"
                inactive-text="否"
                active-value="1"
                inactive-value="0"
                v-else-if="form.type === 'bool'"
                v-model="form.value"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          size="small"
          label="变量名:"
          prop="vCode"
          style="width: 480px"
        >
          <el-input v-model="form.vCode"></el-input>
        </el-form-item>
        <el-form-item
          size="small"
          label="变量标题:"
          prop="title"
          style="width: 480px"
        >
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item
          size="small"
          label="变量描述:"
          prop="tip"
          style="width: 480px"
        >
          <el-input type="textarea" :rows="4" v-model="form.tip"></el-input>
        </el-form-item>
        <el-form-item
          size="small"
          label="排序值:"
          prop="sort_order"
          style="width: 480px"
        >
          <el-input v-model.number="form.sort_order"></el-input>
        </el-form-item>
        <el-form-item
          size="small"
          label="是否必填:"
          prop="is_required"
          style="width: 480px"
        >
          <el-switch
            class="elSwitch"
            v-model.number="form.is_required"
          ></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="onSubmit()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="查看内链"
      :visible.sync="viewLinkDialog"
      width="500px"
      @before-close="close"
      @close="close"
    >
      <div slot="footer" class="dialog-footer">
        <el-form ref="linkForm" :model="linkForm" label-width="100px">
          <el-form-item label="跳转链接">
            <el-select
              v-model="linkForm.link"
              placeholder="请选择跳转链接"
              size="small"
            >
              <el-option
                v-for="item in linkLinks"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="内链ID:"
            prop="inLinkId"
            v-if="
              linkForm.link == 'yinseinner://video?id=' ||
                linkForm.link == 'yinseinner://postInfo?id='
            "
          >
            <el-input size="small" v-model="inLinkId"></el-input>
          </el-form-item>
          <el-form-item label="生成的内链:" prop="tempLink" v-if="tempLink">
            <el-input size="small" v-model="tempLink" disabled></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="close" size="small">取 消</el-button>
          <el-button type="primary" @click="copyLink" size="small"
            >生成链接</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisiblePreview">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <!-- 修改选择项 -->
    <el-dialog :visible.sync="dialogVisibleSelect">
      <el-form
        :model="updateSelectData"
        label-width="200px"
        label-position="left"
      >
        <el-form-item label="">
          <div class="objectBox">
            <el-row :gutter="10">
              <el-col :span="8">键名</el-col>
              <el-col :span="16">键值</el-col>
            </el-row>
            <el-row
              :gutter="10"
              v-for="(item, index) in updateSelectData.selectValues"
              :key="index"
            >
              <el-col :span="8"
                ><el-input
                  type="text"
                  size="small"
                  v-model.trim="item.key"
                ></el-input
              ></el-col>
              <el-col :span="12"
                ><el-input
                  type="text"
                  size="small"
                  v-model.trim="item.value"
                ></el-input
              ></el-col>
              <el-col :span="4"
                ><el-button
                  type="danger"
                  size="small"
                  @click="deleteSelectValue(item.key)"
                  >X</el-button
                >
              </el-col>
            </el-row>
            <el-button size="small" type="success" @click="addSelectValue"
              >追加</el-button
            >
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelSelectUpdate" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="submitSelectUpdate"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import baseConfig from "@/utils/serverUrlConfig";
import local from "@/utils/localStroage";
import API from "@/api";

export default {
  name: "systemConfig",
  data() {
    return {
      // 封面上传地址
      uploadUrl: baseConfig.baseServerUrl + "/vid/uploadStatic",
      header: {
        Authorization: local.get("userInfo").token,
      },
      imgUrl: baseConfig.imgUrl,
      activeName: 0,
      loading: true,
      // 列表数据
      tableData: [],
      data: {},
      rules: {
        gpCode: [
          { required: true, message: "请输入分组编码", trigger: "blur" },
        ],
        groupName: [
          { required: true, message: "请输入分组名", trigger: "blur" },
        ],
      },
      dialogVisible: false,
      objValues: [{ key: "", value: "" }],
      textArray: [""],
      isDisabled: false,
      form: {
        id: undefined,
        gpCode: undefined, // 分组编码
        groupName: undefined, // 分组名
        is_required: false, // 是否必填
        sort_order: 0, // 排序值
        tip: undefined, // 变量描述
        title: undefined, // 变量标题
        vCode: undefined, // 变量名
        value: undefined, // 变量值
        selectValues: undefined, // select类型的选择项
        type: "text", // 类型 text,string,img,int,float,bool,object,text-array,string-array,select
      },
      types: [
        {
          label: "text",
          value: "text",
        },
        {
          label: "string",
          value: "string",
        },
        {
          label: "img",
          value: "img",
        },
        {
          label: "int",
          value: "int",
        },
        {
          label: "float",
          value: "float",
        },
        {
          label: "bool",
          value: "bool",
        },
        {
          label: "object",
          value: "object",
        },
        {
          label: "text-array",
          value: "text-array",
        },
        {
          label: "string-array",
          value: "string-array",
        },
        {
          label: "select",
          value: "select",
        },
      ],
      viewLinkDialog: false,
      inLinkId: undefined,
      linkLinks: [
        { label: "客服", value: "yinseinner://kefu" },
        { label: "推广", value: "yinseinner://universal_agent" },
        { label: "会员", value: "yinseinner://vip_page" },
        { label: "钱包", value: "yinseinner://wallet_page" },
        { label: "发布", value: "yinseinner://publish_page" },
        { label: "视频详情", value: "yinseinner://video?id=" },
        { label: "社区帖子详情", value: "yinseinner://postInfo?id=" },
        { label: "预售", value: "yinseinner://advancePage" },
        { label: "AI科技", value: "yinseinner://aiCenter" },
        { label: "直播", value: "yinseinner://live" },
      ],
      tempLink: undefined,
      linkForm: {
        link: "yinseinner://kefu",
      },
      dialogImageUrl: undefined, // 放大图地址
      dialogVisiblePreview: false, // 放大图
      updateSelectData: {
        id: "",
        selectValues: [{ key: "", value: "" }],
      },
      dialogVisibleSelect: false, // 选择项修改弹框
      selectOptionsType: 2,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // select弹出框删除项
    deleteSelectValue(key) {
      let index = this.updateSelectData.selectValues.findIndex(
        (item) => item.key == key
      );
      this.updateSelectData.selectValues.splice(index, 1);
    },
    // select弹出框追加
    addSelectValue() {
      this.updateSelectData.selectValues.push({ key: "", value: "" });
    },
    cancelSelectUpdate() {
      this.dialogVisibleSelect = false;
    },
    // 确定修改select弹框提交
    submitSelectUpdate() {
      let selectValues = this.updateSelectData.selectValues;
      selectValues = selectValues.filter(
        (item) =>
          item.key !== undefined &&
          item.key !== null &&
          item.key !== "" &&
          item.value !== undefined &&
          item.value !== null &&
          item.value !== ""
      );
      this.updateSelectData.selectValues = selectValues;
      // 点击新增按钮
      if (!this.updateSelectData.id) {
        this.form.selectValues = selectValues;
        this.dialogVisibleSelect = false;
        return;
      }
      // 点击添加变量
      let params = {
        id: this.updateSelectData.id,
        selectValues: selectValues,
      };
      API.updateSysSelect(params).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.dialogVisibleSelect = false;
        }
      });
    },
    // 点击修改选择项按钮
    clickUpdateSelect(type, item) {
      if (type == 1) {
        // 更新返回数据
        this.selectOptionsType = 1;
        this.updateSelectData.id = item.id;
        if (item.selectValues && item.selectValues.length) {
          this.updateSelectData.selectValues = item.selectValues;
        }
      } else {
        this.selectOptionsType = 2;
      }
      this.dialogVisibleSelect = true;
    },
    // 上传图片成功
    uploadImg(res) {
      this.form.value = res.data.coverImg;
    },
    // 上传图片成功
    uploadImgs(obj) {
      this.tableData[obj.groupIndex].map((item, index) => {
        if (index == obj.index) {
          item.value = obj.res.data.coverImg;
        }
      });
    },
    getList() {
      this.loading = true;
      API.getSysconfAll()
        .then((res) => {
          if (res.code === 200 && res.data) {
            let arr = [];
            let obj = res.data.data;
            Object.keys(obj).forEach((key) => {
              obj[key].forEach((item) => {
                if (item.type === "object") {
                  item.value = JSON.parse(item.value);
                  item.values = [];
                  for (const key in item.value) {
                    item.values.push({
                      key: key,
                      value: item.value[key],
                    });
                  }
                }
                if (
                  item.type === "text-array" ||
                  item.type === "string-array"
                ) {
                  item.values = JSON.parse(item.value);
                }
              });
              arr.push(obj[key]);
            });
            this.tableData = arr;
            this.loading = false;
          } else {
            this.tableData = [];
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    deleteValueAll(index, flag) {
      if (flag) {
        this.textArray.splice(index, 1);
      } else {
        this.objValues.splice(index, 1);
      }
    },
    addNodeAll(flag) {
      if (flag) {
        this.textArray.push("");
      } else {
        this.objValues.push({ key: "", value: "" });
      }
    },
    addNode(data, flag) {
      if (flag) {
        data.values.push("");
      } else {
        data.values.push({ key: "", value: "" });
      }
    },
    deleteValue(data, index) {
      data.values.splice(index, 1);
    },
    // 打开新增对话框
    openAdd(item) {
      if (item && item.gpCode) {
        this.form.gpCode = item.gpCode;
        this.form.groupName = item.groupName;
        this.isDisabled = true;
      }
      this.updateSelectData.id = "";
      this.updateSelectData.selectValues = [{ key: "", value: "" }];
      this.dialogVisible = true;
    },
    // 新增
    onSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.type === "object" && !this.objValues.length)
            return this.$message.warning("请输入键名以及键值");
          if (this.form.type === "object") {
            let str = {};
            this.objValues.forEach((v) => {
              let obj = {};
              let key = v.key;
              obj[key] = v.value;
              str = Object.assign(str, obj);
            });
            this.form.value = JSON.stringify(str);
          }
          if (
            this.form.type === "text-array" ||
            this.form.type === "string-array"
          ) {
            this.form.value = JSON.stringify(this.textArray);
          }
          API.addSysconf(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: res.tip || res.msg || "新增失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 修改
    submitUpdate() {
      this.loading = true;
      try {
        let data = this.tableData[this.activeName];
        let newArr = data.map((item) => {
          if (item.type === "object") {
            let str = {};
            item.values.forEach((v) => {
              let obj = {};
              let key = v.key;
              obj[key] = v.value;
              str = Object.assign(str, obj);
            });
            item.value = JSON.stringify(str);
          }
          if (item.type === "text-array" || item.type === "string-array") {
            item.value = JSON.stringify(item.values);
          }
          return {
            id: item.id,
            value: item.value,
          };
        });
        let req = {
          configs: newArr,
        };
        API.updateSysconf(req).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: "更新成功",
            });
            this.handleClose();
            this.getList();
          } else {
            this.$message({
              type: "error",
              message: res.tip || res.msg || "更新失败",
            });
          }
        });
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    // 删除
    del(param) {
      this.$confirm(
        `确认是否删除<span style='color:blue'>${param.title}</span>, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      ).then(() => {
        let delData = {
          id: param.id,
        };
        API.delSysconf(delData).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          } else {
            this.$message({
              type: "success",
              message: res.tip || res.msg || "删除失败!",
            });
          }
          this.getList();
        });
      });
    },
    copyLink() {
      if (
        (this.linkForm.link == "yinseinner://video?id=" ||
          this.linkForm.link == "yinseinner://postInfo?id=") &&
        !this.inLinkId
      )
        return this.$message.error("请填写内链ID");
      if (
        this.linkForm.link == "yinseinner://video?id=" ||
        this.linkForm.link == "yinseinner://postInfo?id="
      ) {
        this.tempLink = this.linkForm.link + this.inLinkId;
      } else {
        this.tempLink = this.linkForm.link;
      }
      if (navigator.clipboard) {
        // clipboard api 复制
        navigator.clipboard.writeText(this.tempLink);
        this.$message.success("已复制链接");
      } else {
        var textarea = document.createElement("textarea");
        document.body.appendChild(textarea);
        // 隐藏此输入框
        textarea.style.position = "fixed";
        textarea.style.clip = "rect(0 0 0 0)";
        textarea.style.top = "10px";
        // 赋值
        textarea.value = this.tempLink;
        // 选中
        textarea.select();
        // 复制
        document.execCommand("copy", true);
        // 移除输入框
        document.body.removeChild(textarea);
        this.$message.success("已复制链接");
      }
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.id = undefined;
      this.form.gpCode = undefined;
      this.form.groupName = undefined;
      this.form.tip = undefined;
      this.form.title = undefined;
      this.form.vCode = undefined;
      this.form.value = undefined;
      this.form.selectValues = undefined;
      this.form.sort_order = 0;
      this.form.is_required = false;
      this.form.type = "text";
      this.objValues = [{ key: "", value: "" }];
      this.updateSelectData.id = "";
      this.updateSelectData.selectValues = [{ key: "", value: "" }];
      this.textArray = [""];
      this.isDisabled = false;
      this.dialogVisible = false;
    },
    viewImg(obj) {
      this.dialogImageUrl = this.imgUrl + obj.value;
      this.dialogVisiblePreview = true;
    },
    close() {
      this.linkForm.link = undefined;
      this.tempLink = undefined;
      this.inLinkId = undefined;
      this.viewLinkDialog = false;
    },
  },
};
</script>
<style scoped lang="scss">
/deep/ .el-form-item__content {
  display: flex;
  align-items: center;
}
/deep/ .el-select {
  width: 100%;
}
/deep/ .el-input {
  margin-bottom: 10px;
}
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
/deep/ .el-textarea {
  width: 80%;
}
.elSwitch {
  margin-top: 5px;
}
.systemConfig {
  .card {
    margin-top: 20px;
    .titleBox {
      display: flex;
      font-weight: 500;
      margin-bottom: 20px;
      .leftBox {
        width: 200px;
      }
      .rightBox {
        flex: 1;
      }
    }
    .contentBox {
      width: 100%;
      .itemBoxs {
        width: 100%;
        .itemBox {
          display: flex;
          align-items: center;
          .objBox {
            width: 60%;
            margin-right: 10px;
            ::v-deep .el-col > .el-input {
              width: 100%;
            }
          }
          .itemBoxs-select-box {
            display: flex;
            align-items: center;
            justify-content: center;
            /deep/ .el-input {
              margin-bottom: 0;
            }
            .itemBoxs-select-btn {
              margin-left: 6px;
            }
          }
        }
      }
    }
    .delBtn {
      height: 28px;
      width: 40px;
      margin-left: 20px;
    }
  }
}
.stringArrayBox {
  margin-bottom: 10px;
}
.tip {
  font-size: 16px;
  font-weight: 500;
  color: red;
}
</style>
